export default __webpack_public_path__ + "static/leaves-1e5db58cf94d2fc77ff3ee937af55384.webp";